import {
  WellbeingAwarenessDaysCalendarPage,
  WellbeingAwarenessDaysCalendarPageQuery,
} from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_WELLBEING_AWARENESS_DAYS_CALENDAR_PAGE } from '@/graphql/queries/wellbeing-awareness-days-calendar/wellbeing-awareness-days-calendar';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<WellbeingAwarenessDaysCalendarPageQuery>({
      query: QUERY_WELLBEING_AWARENESS_DAYS_CALENDAR_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.wellbeingAwarenessDaysCalendarPage?.data?.attributes as WellbeingAwarenessDaysCalendarPage,
    error,
  };
};
